import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Acne treatment type.
 */
export const AcneTreatment: TreatmentType = new TreatmentType({
  id: '21',
  name: ConsultationTreatmentTypes.Acne,
});
